import { useRouter } from 'next/router'
import { useMemo } from 'react'

export const usePageId: () => string = () => {
  const router = useRouter()
  return useMemo(() => {
    const pageId = router.query.pageId?.toString() || ''
    return pageId
  }, [router.query.pageId])
}
